export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-2-line' },
  { slug: 'korean', name: '韩漫', icon: 'ri-kakao-talk-line' },
  { slug: 'japanese', name: '日漫', icon: 'ri-sun-line' },
  { slug: 'chinese', name: '国漫', icon: 'ri-china-railway-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'action', name: '热血', icon: 'ri-fire-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
];

export interface ComicChapter {
  id: number;
  title: string;
  number: number;
  updatedAt: string;
  isFree: boolean;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  tags: string[];
  rating: number;
  views: number;
  status: '连载中' | '已完结';
  updatedAt: string;
  chapters: ComicChapter[];
  isHot: boolean;
  isNew: boolean;
  rank: number;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '秘密教学',
    author: 'YONGCHAN',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%20style%2C%20young%20couple%20in%20school%20uniform%2C%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20clean%20minimal%20composition%2C%20white%20background%2C%20professional%20illustration&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '从小一起长大的青梅竹马，在进入大学后开始了一段秘密的教学关系。看似单纯的课程辅导背后，隐藏着两人内心深处的感情...',
    category: 'korean',
    tags: ['恋爱', '校园', '甜蜜'],
    rating: 9.6,
    views: 12580000,
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 1, title: '第1话 - 新学期的开始', number: 1, updatedAt: '2025-01-10', isFree: true },
      { id: 2, title: '第2话 - 图书馆的秘密', number: 2, updatedAt: '2025-01-17', isFree: true },
      { id: 3, title: '第3话 - 心动的瞬间', number: 3, updatedAt: '2025-01-24', isFree: true },
      { id: 4, title: '第4话 - 无法言说', number: 4, updatedAt: '2025-02-01', isFree: false },
      { id: 5, title: '第5话 - 突如其来的告白', number: 5, updatedAt: '2025-02-08', isFree: false },
    ],
    isHot: true,
    isNew: false,
    rank: 1,
  },
  {
    id: 2,
    title: '剑尊归来',
    author: 'HUINE',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20cover%2C%20swordsman%20in%20traditional%20hanfu%20with%20long%20sword%2C%20ancient%20Chinese%20palace%20background%2C%20ink%20wash%20painting%20style%2C%20dramatic%20lighting%2C%20epic%20fantasy%20atmosphere%2C%20clean%20composition&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '天下第一剑尊在飞升之际被暗算陨落，重生回到百年前的年少时期。带着前世的记忆和绝世剑法，他誓要改变一切！',
    category: 'chinese',
    tags: ['热血', '武侠', '重生'],
    rating: 9.8,
    views: 25600000,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 11, title: '第1话 - 陨落', number: 1, updatedAt: '2025-03-01', isFree: true },
      { id: 12, title: '第2话 - 重生', number: 2, updatedAt: '2025-03-08', isFree: true },
      { id: 13, title: '第3话 - 剑道之路', number: 3, updatedAt: '2025-03-15', isFree: true },
      { id: 14, title: '第4话 - 初露锋芒', number: 4, updatedAt: '2025-03-22', isFree: false },
    ],
    isHot: true,
    isNew: false,
    rank: 2,
  },
  {
    id: 3,
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20style%2C%20demon%20slayer%20character%20with%20katana%2C%20traditional%20Japanese%20pattern%20background%2C%20dark%20blue%20and%20red%20color%20scheme%2C%20action%20pose%2C%20anime%20art%20style%2C%20professional%20illustration&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '大正时期的日本，少年炭治郎一家惨遭鬼的杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹恢复成人类的方法，炭治郎踏上了成为鬼杀队剑士的道路。',
    category: 'japanese',
    tags: ['热血', '战斗', '冒险'],
    rating: 9.7,
    views: 45000000,
    status: '已完结',
    updatedAt: '2026-07-28',
    chapters: [
      { id: 21, title: '第1话 - 残酷', number: 1, updatedAt: '2023-01-01', isFree: true },
      { id: 22, title: '第2话 - 培育者', number: 2, updatedAt: '2023-01-08', isFree: true },
      { id: 23, title: '第3话 - 最终选拔', number: 3, updatedAt: '2023-01-15', isFree: true },
      { id: 24, title: '第4话 - 第一任务', number: 4, updatedAt: '2023-01-22', isFree: true },
    ],
    isHot: true,
    isNew: false,
    rank: 3,
  },
  {
    id: 4,
    title: '女神降临',
    author: 'YAONGYI',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20beauty%20makeup%20theme%20cover%2C%20pretty%20girl%20with%20makeup%20brush%2C%20glamorous%20transformation%20theme%2C%20soft%20pink%20and%20rose%20tones%2C%20fashion%20illustration%20style%2C%20clean%20white%20background&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '因为长相丑陋而遭受校园霸凌的女孩，通过化妆术实现了惊人的变身，成为了校园里的女神。在美貌和真实之间，她该如何选择？',
    category: 'korean',
    tags: ['恋爱', '校园', '化妆'],
    rating: 9.4,
    views: 18900000,
    status: '已完结',
    updatedAt: '2026-07-15',
    chapters: [
      { id: 31, title: '第1话 - 丑小鸭', number: 1, updatedAt: '2024-06-01', isFree: true },
      { id: 32, title: '第2话 - 变身', number: 2, updatedAt: '2024-06-08', isFree: true },
    ],
    isHot: false,
    isNew: false,
    rank: 4,
  },
  {
    id: 5,
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20manhua%20cover%2C%20young%20man%20with%20mysterious%20powers%2C%20modern%20city%20meets%20ancient%20Chinese%20mysticism%2C%20dynamic%20action%20pose%2C%20vivid%20colors%2C%20Chinese%20comic%20art%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '普通大学生张楚岚在爷爷的坟墓被盗后，意外卷入了异人世界的纷争。从此，一个隐藏在现代社会背后的神秘世界向他敞开了大门。',
    category: 'chinese',
    tags: ['热血', '超能力', '冒险'],
    rating: 9.5,
    views: 32000000,
    status: '连载中',
    updatedAt: '2026-08-02',
    chapters: [
      { id: 41, title: '第1话 - 异人', number: 1, updatedAt: '2025-05-01', isFree: true },
      { id: 42, title: '第2话 - 冯宝宝', number: 2, updatedAt: '2025-05-08', isFree: true },
    ],
    isHot: true,
    isNew: false,
    rank: 5,
  },
  {
    id: 6,
    title: '咒术回战',
    author: '芥见下下',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20jujutsu%20sorcery%20theme%20cover%2C%20dark%20haired%20boy%20with%20supernatural%20energy%2C%20Japanese%20urban%20fantasy%20setting%2C%20blue%20flame%20effects%2C%20action%20manga%20art%20style%2C%20dramatic%20composition&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '高中生虎杖悠仁在吞下诅咒之王两面宿傩的手指后，成为了宿傩的容器。为了收集散落各地的宿傩手指，他加入了东京都立咒术高等专门学校。',
    category: 'japanese',
    tags: ['热血', '战斗', '黑暗奇幻'],
    rating: 9.6,
    views: 38000000,
    status: '连载中',
    updatedAt: '2026-08-01',
    chapters: [
      { id: 51, title: '第1话 - 两面宿傩', number: 1, updatedAt: '2025-02-01', isFree: true },
      { id: 52, title: '第2话 - 为了自己', number: 2, updatedAt: '2025-02-08', isFree: true },
    ],
    isHot: true,
    isNew: false,
    rank: 6,
  },
  {
    id: 7,
    title: '乖乖女的恋爱指南',
    author: '柳书',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%2C%20shy%20girl%20and%20popular%20boy%20in%20school%20setting%2C%20sweet%20romantic%20atmosphere%2C%20soft%20pink%20cherry%20blossom%20theme%2C%20manhwa%20art%20style%2C%20clean%20pastel%20colors&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '从小到大都是乖乖女的郑多恩，在大学里遇到了玩世不恭的学长。两个完全不同世界的人，却因为一次偶然的邂逅，开始了啼笑皆非的恋爱故事。',
    category: 'korean',
    tags: ['恋爱', '校园', '搞笑'],
    rating: 9.3,
    views: 8700000,
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 61, title: '第1话 - 乖乖女', number: 1, updatedAt: '2025-09-01', isFree: true },
      { id: 62, title: '第2话 - 意外邂逅', number: 2, updatedAt: '2025-09-08', isFree: true },
    ],
    isHot: false,
    isNew: true,
    rank: 7,
  },
  {
    id: 8,
    title: '斗罗大陆',
    author: '唐家三少',
    cover: 'https://readdy.ai/api/search-image?width=400&height=560&seq=comic-cover-08&orientation=portrait&query=Chinese%20fantasy%20manhua%20cover%2C%20young%20boy%20with%20blue%20silver%20grass%20martial%20spirit%2C%20ancient%20Chinese%20fantasy%20world%2C%20epic%20adventure%20theme%2C%20vibrant%20colors%2C%03Chinese%20comic%20illustration%20style',
    description: '唐门外门弟子唐三，因偷学内门绝学被追杀至悬崖边。跳崖明志后，来到了另一个世界——斗罗大陆。在这里，没有魔法，没有斗气，只有武魂！',
    category: 'chinese',
    tags: ['热血', '奇幻', '冒险'],
    rating: 9.5,
    views: 52000000,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 71, title: '第1话 - 穿越', number: 1, updatedAt: '2025-01-01', isFree: true },
      { id: 72, title: '第2话 - 武魂觉醒', number: 2, updatedAt: '2025-01-08', isFree: true },
    ],
    isHot: true,
    isNew: false,
    rank: 8,
  },
  {
    id: 9,
    title: '天空侵犯',
    author: '三浦追傩',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20survival%20horror%20manga%20cover%2C%20girl%20on%20rooftop%20in%20mysterious%20high-rise%20world%2C%20suspense%20thriller%20atmosphere%2C%20dark%20urban%20landscape%2C%20manga%20art%20style%2C%20dramatic%20tension&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '本城游理突然醒来，发现自己身处一个只有超高建筑相连的异世界。在这里，戴着面具的神秘人四处追杀人类，而跳下楼就必死无疑。',
    category: 'japanese',
    tags: ['悬疑', '生存', '惊悚'],
    rating: 9.1,
    views: 15600000,
    status: '已完结',
    updatedAt: '2026-06-20',
    chapters: [
      { id: 81, title: '第1话 - 异世界', number: 1, updatedAt: '2024-01-01', isFree: true },
      { id: 82, title: '第2话 - 面具人', number: 2, updatedAt: '2024-01-08', isFree: true },
    ],
    isHot: false,
    isNew: false,
    rank: 9,
  },
  {
    id: 10,
    title: '社长大人别太坏',
    author: '樱桃小丸子',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20office%20romance%20webtoon%20cover%2C%20handsome%20CEO%20and%20cute%20female%20employee%2C%20office%20setting%2C%20romantic%20comedy%20vibe%2C%20warm%20color%20palette%2C%20manhwa%20illustration%20style&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '刚入职的职场新人林小月，万万没想到自己顶头上司竟是高中时期被自己拒绝过的学长。更可怕的是，这位社长大人似乎对当年的事记忆犹新...',
    category: 'korean',
    tags: ['恋爱', '职场', '搞笑'],
    rating: 9.2,
    views: 10200000,
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 91, title: '第1话 - 入职第一天', number: 1, updatedAt: '2025-11-01', isFree: true },
      { id: 92, title: '第2话 - 冤家路窄', number: 2, updatedAt: '2025-11-08', isFree: true },
    ],
    isHot: false,
    isNew: true,
    rank: 10,
  },
  {
    id: 11,
    title: '镇魂街',
    author: '许辰',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20action%20manhua%20cover%2C%20young%20man%20with%20guardian%20spirit%2C%20ancient%20Chinese%20warrior%20ghost%2C%20modern%20and%20ancient%20fusion%2C%20dramatic%20composition%2C%20Chinese%20comic%20art&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '普通的应届毕业生夏铃，在求职之际收到了一条奇怪的面试通知，误入罗刹街后，她的命运发生了翻天覆地的变化——这个世界存在着守护灵！',
    category: 'chinese',
    tags: ['热血', '奇幻', '守护灵'],
    rating: 9.4,
    views: 28000000,
    status: '连载中',
    updatedAt: '2026-07-30',
    chapters: [
      { id: 101, title: '第1话 - 罗刹街', number: 1, updatedAt: '2025-06-01', isFree: true },
      { id: 102, title: '第2话 - 守护灵', number: 2, updatedAt: '2025-06-08', isFree: true },
    ],
    isHot: false,
    isNew: false,
    rank: 11,
  },
  {
    id: 12,
    title: '间谍过家家',
    author: '远藤达哉',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20spy%20family%20comedy%20manga%20cover%2C%20man%20in%20suit%20with%20little%20girl%20and%20woman%2C%20warm%20family%20theme%20with%20spy%20elements%2C%20light%20comedy%20style%2C%20manga%20art%2C%20clean%20illustration&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '为了执行机密任务，顶尖间谍"黄昏"需要组建一个临时家庭。他收养了能读心的超能力女孩阿尼亚，又找到了身份神秘的杀手妻子约尔。一个奇妙的伪装家庭就此诞生！',
    category: 'japanese',
    tags: ['搞笑', '家庭', '间谍'],
    rating: 9.7,
    views: 41000000,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 111, title: '第1话 - 任务开始', number: 1, updatedAt: '2025-04-01', isFree: true },
      { id: 112, title: '第2话 - 寻找家人', number: 2, updatedAt: '2025-04-08', isFree: true },
    ],
    isHot: true,
    isNew: false,
    rank: 12,
  },
];